import { render } from "./Invited.vue?vue&type=template&id=52db95ec&scoped=true"
import script from "./Invited.vue?vue&type=script&lang=js"
export * from "./Invited.vue?vue&type=script&lang=js"

import "./Invited.vue?vue&type=style&index=0&id=52db95ec&lang=less&scoped=true"

import exportComponent from "/drone/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52db95ec"]])

export default __exports__